<template>
    <div class="row" :style="rowStyle">
        <div class="form-inline col-md-2">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon color="grey lighten-1" class="tooltip-small">
                            mdi-information-outline
                        </v-icon>
                    </v-btn>
                </template>
                <span>Select filter that should be applied on data.</span>
            </v-tooltip>

            <i class="fas fa-filter"></i> <span style="padding-left: 5px;">Filters </span>
        </div>

        <div class="form-group col-md-4">
            <template>
                <v-container fluid>
                    <v-select
                        v-model="filters"
                        :items="$store.getters['CreateAudienceStore/getFiltersAll'](dataSetOrder)"
                        label="Filters"
                        multiple
                    >
                        <template v-slot:selection="{ item, index }">
                            <v-chip small v-if="index === 0">
                                <span>{{ item.text.substr(0, 7) }}...</span>
                            </v-chip>
                            <span
                                v-if="index === 1"
                                class="grey--text text-caption"
                            >
                              +{{ $store.getters['CreateAudienceStore/getFiltersSelected'](dataSetOrder).length - 1 }}
                            </span>
                        </template>
                    </v-select>
                </v-container>
            </template>
        </div><!--form-group-->
    </div>
</template>

<script>
import analyses from "../../../../mixin/analyses";

export default {
    name: "Filters",
    mixins: [analyses],
    props: [
        'dataSetOrder',
        'rowStyle',
        'analysisType'
    ],
    data: () => ({
        poi_filters: [
            {
                value: 'anomalous_devices',
                text: 'Filter Anomalous Devices'
            },
            {
                value: 'gps_only',
                text: 'Not-Flagged IP Address Only'
            },
            {
                value: 'anomalous_pois',
                text: 'Filter Anomalous POIs'
            },
        ],
        anonymized_filters: [
            {
                value: 'anomalous_devices',
                text: 'Filter Anomalous Devices'
            },
            {
                value: 'gps_only',
                text: 'Filter By Device GPS Only'
            }
        ],
    }),
    methods: {
        setFilterOptions() {
            if ([
                this.$store.getters['CreateAudienceStore/getAnalysisType'](0),
                this.$store.getters['CreateAudienceStore/getAnalysisType'](1)
            ].includes(this.analyses.types.poi) && [this.analyses.types.poi, this.analyses.types.competitors].includes(this.analysisType)) {
                this.$store.commit('CreateAudienceStore/SET_FILTERS_ALL', {
                    dataset: this.dataSetOrder,
                    value: this.poi_filters
                })
                this.alignFiltersUsage(this.analyses.types.poi)

            } else if ([this.$store.getters['CreateAudienceStore/getAnalysisType'](0)].includes(this.analyses.types.anonymized)) {
                this.$store.commit('CreateAudienceStore/SET_FILTERS_ALL', {
                    dataset: this.dataSetOrder,
                    value: this.anonymized_filters
                })
                this.alignFiltersUsage(this.analyses.types.anonymized)

            } else if (this.$store.getters['CreateAudienceStore/getAnalysesCrossVisitationStatus']) {
                this.$store.commit('CreateAudienceStore/SET_FILTERS_ALL', {
                    dataset: this.dataSetOrder,
                    value: this.poi_filters
                })
                this.alignFiltersUsage(this.analyses.additional.cross_visitation)

            }
        },
        getFiltersArrayByAnalysisType(analysis_type) {
            let filters = []

            if ([this.analyses.types.poi, this.analyses.types.competitors, this.analyses.additional.cross_visitation].includes(analysis_type)) {
                this.poi_filters.forEach((item) => {
                    filters.push(item.value)
                })
            } else if (analysis_type === this.analyses.types.anonymized) {
                this.anonymized_filters.forEach((item) => {
                    filters.push(item.value)
                })
            }

            return filters
        },
        alignFiltersUsage(analysis_type) {
            let filters = this.getFiltersArrayByAnalysisType(analysis_type)
            let new_filters = []

            this.$store.getters['CreateAudienceStore/getFiltersSelected'](this.dataSetOrder).forEach((item) => {
                if (filters.includes(item)) {
                    new_filters.push(item)
                }
            })

            this.$store.commit('CreateAudienceStore/SET_FILTERS_SELECTED', {
                dataset: this.dataSetOrder,
                value: new_filters
            })
        },
    },
    created() {
        //
    },
    mounted() {
        this.$store.commit('CreateAudienceStore/SET_FILTERS_ALL', {
            dataset: this.dataSetOrder,
            value: this.poi_filters
        })
        this.setFilterOptions()
    },
    computed: {
        filters: {
            get() {
                return this.$store.getters['CreateAudienceStore/getFiltersSelected'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_FILTERS_SELECTED', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        analysis_type: {
            get() {
                return this.analysisType
            }
        }
    },
    watch: {
        analysisType: function () {
            this.setFilterOptions()
        }
    }
}
</script>

<style scoped>

</style>